export const SURVEY_TRACKING_MESSAGES = {
  LANDING_VIEW: 'InProgress-Yoda-Yoda Survey Start Page',
  CONTINUE_CLICKED: 'InProgress-Yoda-Clicked on Continue Button at Yoda',
  REDIRECT_TO_SCREENER: 'InProgress-Yoda-Redirected to Pre-Screener Page',
  REDIRECT_TO_CALLBACK: 'InProgress-Yoda-Redirected to Callback Page with Status={status}',
  ERROR_IN_CLICK_THROTTLE: 'InProgress-Yoda-Error: Yoda_Click Throttle API',
  ERROR_IN_SERVICE_TYPE: 'InProgress-Yoda-Error: Yoda_Integrated Security Service Function API',
  ERROR_IN_RDINFO: 'InProgress-Yoda-Error: Yoda_RdInfoSecurityCheck API',
  ERROR_IN_START: 'InProgress-Yoda-Error: Yoda_Start API',
  DROPOUT: 'InProgress-Yoda-DropOut on Yoda Survey Landing Page',
  INACTIVE: 'InProgress-Yoda_No Interaction [5 Mins]',
  OPT_OUT: 'InProgress-Yoda-Yoda Opt-Out',
  REDIRECT_TO_CLIENT: 'InProgress-Yoda-Redirected to Client Survey',
  REDIRECT_TO_OLD_SCREENER: 'InProgress-Yoda-Redirected to Old Yoda Screener',
  ERROR_IN_TrackUpdate: 'InProgress-Yoda-Error: TrackUpdate API',
  ERROR_SCREENER_LINK: 'InProgress-Yoda-Error: Screener link not available',
  ERROR_SCREENER_REDIRECT: 'InProgress-Yoda-Error: Screener redirect failed',
  ERROR_SURVEY_LOG_ID: 'InProgress-Yoda-Error: SurveyLogId not available',
} as const;

export type SurveyTrackingMessageKey = keyof typeof SURVEY_TRACKING_MESSAGES;
